export default "__VITE_ASSET__Dxnp1NyN__";